<template>
  <div class="CadastroConfigFuncaoProjetos">
    <el-button
      v-if="permissao.editar_configuracoes"
      style="float: right; padding: 5px 5px"
      @click="dialogFormVisible = true"
      icon="el-icon-circle-plus"
      type="primary"
      plain
      round
    >Novo Texto</el-button>
    <el-table :data="listTextos" empty-text="Sem dados!">
      <el-table-column width="100" property="id" label="Cód."></el-table-column>
      <el-table-column property="campo" label="Campo"></el-table-column>
      <el-table-column property="titulo" label="Título"></el-table-column>
      <el-table-column property="tipo" label="Tipo"></el-table-column>
      <el-table-column property="ordem" label="Ordem"></el-table-column>
      <el-table-column prop="acao" label="Ação" filter-placement="bottom-end">
        <template v-if="permissao.editar_configuracoes" slot-scope="scope">
          <el-button-group>
            <el-button
              size="mini"
              type="primary"
              @click="handleEditarTexto(scope.$index, scope.row)"
              icon="el-icon-edit"
            ></el-button>
            <el-tooltip
              v-if="permissao.excluir_configuracoes"
              class="item"
              effect="light"
              content="Excluir"
              placement="top"
            >
              <el-button
                size="mini"
                type="danger"
                @click="handleDeleteTexto(scope.$index, scope.row)"
                icon="el-icon-delete"
              ></el-button>
            </el-tooltip>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <!-- DIALOG DE CADASTRO DE CONFIGURAÇÃO TEXTO -->
    <el-dialog title="Novo Texto" :visible="dialogFormVisible" :show-close="false">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        :label-position="labelPosition"
        class="demo-ruleForm"
      >
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Campo" prop="campo">
              <el-input v-model="ruleForm.campo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Slug" prop="slug">
              <el-input v-model="ruleForm.slug"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Tipo" prop="tipo">
              <el-select v-model="ruleForm.tipo" placeholder="Informe o tipo de campo.">
                <el-option label="Proposta" value="P"></el-option>
                <el-option label="Apresentação" value="A"></el-option>
                <el-option label="Conteúdo" value="C"></el-option>
                <el-option label="Assinatura - Proposta" value="AP"></el-option>
                <el-option label="Assinatura - Conteúdo" value="AC"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Ordem" prop="ordem">
              <el-input v-model="ruleForm.ordem"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Titulo" prop="titulo">
              <el-input v-model="ruleForm.titulo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Subtitulo" prop="subtitulo">
              <el-input v-model="ruleForm.subtitulo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label prop="texto">
              <vue-editor id="texto" v-model="ruleForm.texto" :editor-toolbar="customToolbar"></vue-editor>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleFechar()">Cancelar</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">Salvar</el-button>
      </span>
    </el-dialog>

    <!-- DIALOG DE EDIÇÃO DE CONFIGURAÇÃO DE TEXTO -->
    <el-dialog title="Alterar Texto" :visible="dialogFormEditVisible" :show-close="false">
      <el-form
        :model="ruleEditForm"
        :rules="rules"
        ref="ruleEditForm"
        :label-position="labelPosition"
      >
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="5" :lg="4" :xl="4">
            <el-form-item label="Código" prop="id">
              <el-input v-model="ruleEditForm.id" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
            <el-form-item label="Campo" prop="campo">
              <el-input v-model="ruleEditForm.campo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="9" :lg="10" :xl="10">
            <el-form-item label="Slug" prop="slug">
              <el-input v-model="ruleEditForm.slug"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Tipo" prop="tipo">
              <el-select v-model="ruleEditForm.tipo" placeholder="Informe o tipo de campo.">
                <el-option label="Proposta" value="P"></el-option>
                <el-option label="Apresentação" value="A"></el-option>
                <el-option label="Conteúdo" value="C"></el-option>
                <el-option label="Assinatura - Proposta" value="AP"></el-option>
                <el-option label="Assinatura - Conteúdo" value="AC"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Ordem" prop="ordem">
              <el-input v-model="ruleEditForm.ordem"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Titulo" prop="titulo">
              <el-input v-model="ruleEditForm.titulo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="Subtitulo" prop="subtitulo">
              <el-input v-model="ruleEditForm.subtitulo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label prop="texto">
              <vue-editor id="texto" v-model="ruleEditForm.texto" :editor-toolbar="customToolbar"></vue-editor>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleEditFechar()">Cancelar</el-button>
        <el-button type="primary" @click="submitEditForm('ruleEditForm')">Salvar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";
import { VueEditor } from "vue2-editor";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      customToolbar: [
      ["bold", "italic", "underline","strike"],
      [{ list: "ordered" }, { list: "bullet" }]
      ],      
      labelPosition: "right",
      dialogFormVisible: false,
      dialogFormEditVisible: false,
      listTextos: [],
      permissao: {},
      ruleForm: {
        campo: "",
        slug: "",
        texto: "",
        tipo: "", //P=proposta; A=apresentação; C=conteúdo; AA=assinaturas - apresentação; AP=assinaturas proposta
        ordem: "",
        titulo: "",
        subtitulo: "",
      },
      ruleEditForm: {
        campo: "",
        slug: "",
        texto: "",
        tipo: "", //P=proposta; A=apresentação; C=conteúdo; AA=assinaturas - apresentação; AP=assinaturas proposta
        ordem: "",
        subtitulo: "",
        titulo: "",
        id: "",
      },
      rules: {
        campo: [
          {
            required: true,
            message: "Informe o nome do Campo",
            trigger: "blur",
          },
        ],
        slug: [
          {
            required: true,
            message: "Informe o nome do Slug, sem espaços e acentos",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_configuracoes) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.getDadosTexto();
  },
  methods: {
    getDadosTexto: function () {
      axios
        .get(url + "/textos", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.listTextos = response.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.total = "erro" + err;
        });
    },
    //CADASTRO DADOS
    handleFechar() {
      this.$confirm("Tem certeza que deseja sair?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.dialogFormVisible = false;
          this.ruleForm.campo     = "";
          this.ruleForm.slug      = "";
          this.ruleForm.texto     = "";
          this.ruleForm.tipo      = "";
          this.ruleForm.ordem     = "";
          this.ruleForm.titulo    = "";
          this.ruleForm.subtitulo = "";
        })
        .catch(() => {
          this.dialogFormVisible = true;
        });
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let dados = {
            campo:     this.ruleForm.campo,
            slug:      this.ruleForm.slug,
            texto:     this.ruleForm.texto,
            tipo:      this.ruleForm.tipo,
            ordem:     this.ruleForm.ordem,
            titulo:    this.ruleForm.titulo,
            subtitulo: this.ruleForm.subtitulo,
          };
          axios
            .post(url + "/textos/", dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro Salvo com sucesso!",
                type: "success",
              });
              this.dialogFormVisible = false;
              this.ruleForm.campo     = "";
              this.ruleForm.slug      = "";
              this.ruleForm.texto     = "";
              this.ruleForm.tipo      = "";
              this.ruleForm.ordem     = "";
              this.ruleForm.titulo    = "";
              this.ruleForm.subtitulo = "";
              this.getDadosTexto();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao cadastrar os dados! Tente novamente mais tarde!" +
                  err,
                type: "error",
              });
              this.dialogFormVisible = false;
              this.ruleForm.campo     = "";
              this.ruleForm.slug      = "";
              this.ruleForm.texto     = "";
              this.ruleForm.tipo      = "";
              this.ruleForm.ordem     = "";
              this.ruleForm.titulo    = "";
              this.ruleForm.subtitulo = "";
              this.$refs.tree.setCheckedKeys([]);
            });
        } else {
          this.$message({
            type: "info",
            message: "Informe os dados corretamente!",
          });
          return false;
        }
      });
    },
    //FIM CADASTRO DADOS
    //EXCLUIR DADOS RENTABILIDADE
    handleDeleteTexto(index, row) {
      this.$confirm("Tem certeza que deseja excluir este registro?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(url + "/textos/" + row.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              //this.itens = response.data;
              this.$notify({
                title: "Sucesso",
                message: "Registro excluído com Sucesso!",
                type: "success",
              });
              this.getDadosTexto();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    //FIM EXCLUIR DADOS COMISSÃO
    //EDITAR DADOS CAMPOS
    handleEditarTexto(index, row) {
      axios
        .get(url + "/textos/" + row.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          this.dialogFormEditVisible = true;
          this.ruleEditForm.campo = resp.data.campo;
          this.ruleEditForm.id = row.id;
          this.ruleEditForm.slug = resp.data.slug;
          this.ruleEditForm.texto = resp.data.texto;
          this.ruleEditForm.tipo = resp.data.tipo;
          this.ruleEditForm.ordem = resp.data.ordem;
          this.ruleEditForm.titulo = resp.data.titulo;
          this.ruleEditForm.subtitulo = resp.data.subtitulo;
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
          this.dialogFormEditVisible = false;
        });
    },

    //EDITAR DADOS GRUPOS
    submitEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let dados = {
            campo: this.ruleEditForm.campo,
            slug: this.ruleEditForm.slug,
            tipo: this.ruleEditForm.tipo,
            ordem: this.ruleEditForm.ordem,
            texto: this.ruleEditForm.texto,
            titulo: this.ruleEditForm.titulo,
            subtitulo: this.ruleEditForm.subtitulo,

          };

          axios
            .put(url + "/textos/" + this.ruleEditForm.id, dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro Salvo com sucesso!",
                type: "success",
              });
              this.dialogFormEditVisible = false;
              this.ruleEditForm.campo = "";
              this.ruleEditForm.slug = "";
              this.ruleEditForm.tipo = "";
              this.ruleEditForm.ordem = "";
              this.ruleEditForm.texto = "";
              this.ruleEditForm.titulo = "";
              this.ruleEditForm.subtitulo = "";

              this.getDadosTexto();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao cadastrar os dados! Tente novamente mais tarde!" +
                  err,
                type: "error",
              });
              this.dialogFormEditVisible = false;
              this.ruleEditForm.campo = "";
              this.ruleEditForm.slug = "";
              this.ruleEditForm.tipo = "";
              this.ruleEditForm.ordem = "";
              this.ruleEditForm.texto = "";
              this.ruleEditForm.titulo = "";
              this.ruleEditForm.subtitulo = "";
            });
        } else {
          this.$message({
            type: "info",
            message: "Informe os dados corretamente!",
          });
          return false;
        }
      });
    },

    //FECHAR DIALOG EDIT
    handleEditFechar() {
      this.$confirm("Tem certeza que deseja sair?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.dialogFormEditVisible = false;
          this.ruleForm.campo = "";
          this.ruleForm.slug = "";
          this.ruleForm.texto = "";
          this.ruleForm.tipo = "";
          this.ruleForm.ordem = "";
          this.ruleForm.titulo = "";
          this.ruleForm.subtitulo = "";
        })
        .catch(() => {
          this.dialogFormEditVisible = true;
        });
    },
  },
};
</script>